// extracted by mini-css-extract-plugin
export var documentation = "_l3-1";
export var menu = "_l3-0";